// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Cqwa","delete":"styles_delete__1zRfT","update":"styles_update__fM6Z8","add":"styles_add__vFyTO"};